import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { 
  BarChart3, 
  Building2, 
  CreditCard, 
  Database, 
  Globe, 
  LayoutList, 
  Truck, 
  UserPlus, 
  Wallet
} from 'lucide-react';

const EcommerceIntegration = () => {
  return (
    <section id="ecommerce-integration" className="py-16 md:py-28">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Nahtlose System-Integration
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Entfessle das volle Potenzial deiner E-Commerce-Plattform durch intelligente Verbindungen 
            mit all deinen Geschäftssystemen für automatisierte Prozesse und Echtzeitdaten.
          </p>
        </div>

        <div className="relative mb-20">
          {/* Zentrale E-Commerce Plattform */}
          <div className="relative z-10 max-w-sm mx-auto mb-16">
            <Card className="border-0 shadow-lg bg-gradient-to-br from-blue-500 to-indigo-600 text-white">
              <CardContent className="p-8 text-center">
                <div className="rounded-full bg-white/20 p-4 mx-auto mb-4 w-20 h-20 flex items-center justify-center">
                  <Globe className="h-10 w-10" />
                </div>
                <h3 className="text-2xl font-bold mb-3">Deine E-Commerce Plattform</h3>
                <p className="opacity-90">
                  Die zentrale Drehscheibe für alle digitalen Handelsprozesse deines Unternehmens
                </p>
              </CardContent>
            </Card>
            
            {/* Verbindungslinien */}
            <div className="absolute left-1/2 top-full w-0.5 h-12 bg-gray-300 -translate-x-1/2"></div>
            <div className="absolute left-1/2 top-[calc(100%+12px)] w-[600px] h-0.5 bg-gray-300 -translate-x-1/2 hidden md:block"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative">
            <div className="relative">
              <div className="absolute left-1/2 top-0 w-0.5 h-12 bg-gray-300 -translate-x-1/2 -translate-y-12 hidden md:block"></div>
              
              <h3 className="text-xl font-bold mb-6 text-center">Back-Office Systeme</h3>
              <div className="space-y-4">
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <Database className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">ERP-System</h4>
                      <p className="text-sm text-gray-600">Zentrale Daten, Lagerbestände, Bestellabwicklung</p>
                    </div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <UserPlus className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">CRM-System</h4>
                      <p className="text-sm text-gray-600">Kundendaten, Käuferhistorie, Service-Tickets</p>
                    </div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <LayoutList className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">PIM-System</h4>
                      <p className="text-sm text-gray-600">Produktdaten, Medien, Kategorien, Varianten</p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
            
            <div className="relative mt-8 md:mt-0">
              <div className="absolute left-1/2 top-0 w-0.5 h-12 bg-gray-300 -translate-x-1/2 -translate-y-12 hidden md:block"></div>
              
              <h3 className="text-xl font-bold mb-6 text-center">Zahlungs- & Versand</h3>
              <div className="space-y-4">
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <CreditCard className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Payment-Provider</h4>
                      <p className="text-sm text-gray-600">PayPal, Kreditkarte, Klarna, Sofort, Apple Pay</p>
                    </div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <Truck className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Versanddienstleister</h4>
                      <p className="text-sm text-gray-600">DHL, DPD, Hermes, UPS, Spedition</p>
                    </div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <Wallet className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Buchhaltung</h4>
                      <p className="text-sm text-gray-600">DATEV, Lexware, Sage, SAP</p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
            
            <div className="relative mt-8 md:mt-0">
              <div className="absolute left-1/2 top-0 w-0.5 h-12 bg-gray-300 -translate-x-1/2 -translate-y-12 hidden md:block"></div>
              
              <h3 className="text-xl font-bold mb-6 text-center">Marketing & Vertrieb</h3>
              <div className="space-y-4">
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <BarChart3 className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Analytics & Tracking</h4>
                      <p className="text-sm text-gray-600">Google Analytics, Matomo, Hotjar, Piwik PRO</p>
                    </div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <Building2 className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Marktplätze</h4>
                      <p className="text-sm text-gray-600">Amazon, eBay, Otto, Kaufland, Händlerbund</p>
                    </div>
                  </CardContent>
                </Card>
                
                <Card className="bg-white hover:shadow-md transition-all duration-300">
                  <CardContent className="p-5 flex items-start">
                    <div className="rounded-full bg-blue-100 p-2 mr-4">
                      <Globe className="h-5 w-5 text-blue-700" />
                    </div>
                    <div>
                      <h4 className="font-medium mb-1">Marketing-Plattformen</h4>
                      <p className="text-sm text-gray-600">Newsletter, CMS, Social Media, Ads</p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Alle Systeme im Einklang
          </h3>
          <p className="text-gray-600 mb-8">
            Wir entwickeln nicht nur deinen Shop, sondern ein vollständig integriertes E-Commerce-Ökosystem, 
            das alle Geschäftsbereiche synchronisiert und automatisiert. Die bidirektionale Datensynchronisation 
            eliminiert Insellösungen und verhindert doppelte Datenpflege.
          </p>
          <Card className="bg-blue-50 border-0">
            <CardContent className="p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-blue-700 mb-2">-68%</div>
                  <p className="text-sm text-gray-700">Reduzierter manueller Arbeitsaufwand</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-blue-700 mb-2">+42%</div>
                  <p className="text-sm text-gray-700">Höhere Datengenauigkeit</p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-blue-700 mb-2">3x</div>
                  <p className="text-sm text-gray-700">Schnellere Markteinführungszeit</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default EcommerceIntegration; 